import { createContext, useContext, useState, useCallback } from 'react';
import { useNotifications } from './NotificationContext';

const SyncContext = createContext(null);

export const SyncProvider = ({ children }) => {
  const [syncCount,    setSyncCount]    = useState(0);
  const [isSyncing,    setIsSyncing]    = useState(false);
  const [lastSyncTime, setLastSyncTime] = useState(null);
  const { refreshNotifications } = useNotifications();

  const triggerSync = useCallback(async () => {
    if (isSyncing) return;
    setIsSyncing(true);
    await new Promise(resolve => setTimeout(resolve, 1200));
    const now = new Date();
    setSyncCount(c => c + 1);
    setLastSyncTime(now);
    setIsSyncing(false);
    refreshNotifications();
  }, [isSyncing, refreshNotifications]);

  return (
    <SyncContext.Provider value={{
      syncCount, isSyncing, lastSyncTime, triggerSync,
    }}>
      {children}
    </SyncContext.Provider>
  );
};

export const useSync = () => useContext(SyncContext);
